import { getCurrencySymbol } from '@angular/common';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders
} from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {MatSnackBar } from '@angular/material/snack-bar';

import { ActivatedRoute, Router } from '@angular/router';

import {
  TreeList,
  TreeNodeConfig
} from 'framework/lib/dynamic-component/component-configuration.interface';

import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';
import { map, take } from 'rxjs/operators';
import { Urls } from 'src/environments/urls';
// import { RoleProfileChecks } from '../imanage-dashboard/dashboard-carousel/n-bres';
// import { AppConfigService } from '../providers/app-config.service';

//import { RGTDowntime } from '../app-config';
import { CommonDialogComponent } from '../common-dialog/common-dialog.component';
import { RoleProfileChecks } from '../e-sampark/n-bres';

@Injectable({
  providedIn: 'root'
})
export class CommonSharingService {
  isTreeDataChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  isBackbuttonClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  dialogRef!: MatDialogRef<CommonDialogComponent>;
  errorData: any;
  clientId = '1000076139';
  idamApi: any;
  urlConfig: any;
  user!: string;
  Clientrole: string[] = [];
  public loggedInUserCode = new BehaviorSubject(null);
  matchedTreeDt!: any[];
  // updatedNotifCount: EventEmitter<string> = new EventEmitter<string>();
  ismartTreeData: TreeList[] = [
    {
      name: 'My Dashboard',
      logoImg: 'assets/images/HMenu/Group 4327.svg',
      routerLink: 'dashboard'
    },
    {
      name: 'My Profile',
      logoImg: 'assets/images/HMenu/Group 4328.svg',
      routerLink: 'dashboard/myProfile'
    },
    {
      name: 'Bulk Fund Switch',
      logoImg: 'assets/images/HMenu/Group 4334.svg',
      routerLink: 'dashboard/bulk-fund-switch'
    },
    {
      name: 'Fund Performance',
      logoImg: 'assets/images/HMenu/Group 4343.svg',
      redirectTo: ''
    },

    {
      name: 'LMS',
      logoImg: 'assets/images/HMenu/Group 4330.svg',
      redirectTo: ''
    },
    {
      name: 'My Compensation',
      logoImg: 'assets/images/HMenu/Group 4331.svg',
      routerLink: 'dashboard/myCompensation'
    },
    {
      name: 'Update Bank A/C',
      logoImg: 'assets/images/HMenu/Group 4333.svg',
      routerLink: 'dashboard/updateBank'
    },
    {
      name: 'Financial Calculator',
      logoImg: 'assets/images/HMenu/Group 4338.svg',
      routerLink: 'dashboard/financialCalculator'
    },
    {
      name: 'Product Gallery',
      logoImg: 'assets/images/HMenu/Group 4338.svg',
      routerLink: 'dashboard/productGallery'
    },
    {
      name: 'Care Quote',
      logoImg: 'assets/images/HMenu/Group 4342.svg',
      redirectTo: ''
    },
    {
      name: 'Quick Quote',
      logoImg: 'assets/images/HMenu/Group 4330.svg',
      redirectTo: ''
    },
    {
      name: 'Download INStab',
      logoImg: 'assets/images/HMenu/Group 4346.svg',
      routerLink: 'dashboard/downloadInstab'
    },
    {
      name: 'Application Tracker',
      logoImg: 'assets/images/HMenu/Group 4332.svg',
      redirectTo: ''
    },
    {
      name: 'Training Corner',
      logoImg: 'assets/images/HMenu/Group 4334.svg',
      routerLink: 'hamburger-ismart/training-corner'
    },
    {
      name: 'Insta Learn',
      logoImg: 'assets/images/HMenu/Group 4335.svg',
      redirectTo: ''
    },
    {
      name: 'Quality Metrics',
      logoImg: 'assets/images/HMenu/Group 4336.svg',
      routerLink: 'quality-metrics'
    },
    {
      name: 'Quick Link',
      logoImg: 'assets/images/HMenu/Group 4341.svg',
      routerLink: 'dashboard/quickLink'
    },
    {
      name: 'Notice Board',
      logoImg: 'assets/images/HMenu/Group 4345.svg',
      routerLink: 'hamburger-notice/notice'
    },
    {
      name: 'Investment Corner',
      logoImg: 'assets/images/HMenu/Group 4343.svg',
      redirectTo: ''
    },
    {
      name: 'My Corner',
      logoImg: 'assets/images/HMenu/Group 4329.svg',
      routerLink: 'hamburger-ismart/my-corner'
    },
    {
      name: 'Brandstore',
      logoImg: 'assets/images/HMenu/Group 4344.svg',
      redirectTo: ''
    },
    {
      name: 'Opt Notification',
      logoImg: 'assets/images/HMenu/Group 4337.svg',
      redirectTo: ''
    },
    {
      name: 'Feedback',
      logoImg: 'assets/images/HMenu/Group 4339.svg',
      routerLink: 'dashboard/feedback'
    },
    {
      name: 'Help & Support',
      logoImg: 'assets/images/HMenu/Group 4340.svg',
      routerLink: 'dashboard/helpSupport'
    },
    {
      name: 'Refer Now',
      logoImg: 'assets/images/HMenu/Group 4340.svg',
      routerLink: 'dashboard/refer-now'
    },
    {
      name: 'Customer Servicing',
      logoImg: '/assets/images/imanage-icons/Customer Servicing.svg',
      redirectTo: ''
    },
    {
      name: 'Logout',
      logoImg: 'assets/images/HMenu/Group 4347.svg'
    }
  ];

  imanageTreeDataForSM: TreeList[] = [
    {
      name: 'Home',
      logoImg: 'assets/images/HMenu/Group 4329.svg',
      routerLink: 'im-dashboard'
    },
    {
      name: 'My Profile',
      logoImg: 'assets/images/imanage-icons/My Profile.svg',
      routerLink: 'my-profile'
    },
    {
      name: 'Renewals & Persistency',
      logoImg: 'assets/images/imanage-icons/Renewals and Persistency Blue.svg',
      routerLink: 'dashboard/renewalsPersistency'
    },
    {
      name: 'Performance Management',
      logoImg: 'assets/images/imanage-icons/Processes.svg',
      routerLink: 'im-performance-management'
    },
    {
      name: 'Exam Status',
      logoImg: 'assets/images/imanage-icons/Exam Status.svg',
      routerLink: 'exam-status'
    },
    {
      name: 'GPA',
      logoImg: '/assets/im-images/gpa.svg',
      routerLink: 'im-dashboard/gpa'
    },
    {
      name: 'Financial Calculator',
      logoImg: 'assets/images/HMenu/Group 4338.svg',
      routerLink: 'dashboard/financialCalculator'
    },
    {
      name: 'Product Gallery',
      logoImg: 'assets/images/HMenu/Group 4338.svg',
      routerLink: 'dashboard/productGallery'
    },
    {
      name: 'Care Quote',
      logoImg: 'assets/images/imanage-icons/Care Quote.svg',
      redirectTo: ''
    },
    {
      name: 'Customer Services',
      logoImg: '/assets/images/imanage-icons/Customer Servicing.svg',
      routerLink: '/customer-services'
    },
    {
      name: 'Application Tracker',
      logoImg: 'assets/images/HMenu/Group 4332.svg',
      redirectTo: ''
    },
    {
      name: 'IC / POSP Summary',
      logoImg: 'assets/images/imanage-icons/IC  POSP Summary Blue.svg',
      routerLink: 'ic-posp-summary'
    },
    {
      name: 'Forms For Download',
      logoImg: 'assets/images/imanage-icons/Forms For Download.svg',
      redirectTo: ''
    },
    {
      name: 'Resources',
      logoImg: 'assets/images/imanage-icons/Resources.svg',
      routerLink: 'imanage-resources'
    },
    {
      name: 'Quality Metrics',
      logoImg: 'assets/images/imanage-icons/Quality matrix.svg',
      routerLink: 'quality-metrics'
    },
    {
      name: 'Notice',
      logoImg: 'assets/images/imanage-icons/Notice.svg',
      routerLink: 'hamburger-notice/notice'
    },
    {
      name: 'Investment Corner',
      logoImg: 'assets/images/imanage-icons/Investment Corner.svg',
      redirectTo: ''
    },
    {
      name: 'Brandstore',
      logoImg: 'assets/images/imanage-icons/Brandstore.svg',
      redirectTo: ''
    },
    /*{
      name: 'i-RECRUIT',
      logoImg: 'assets/images/imanage-icons/i-RECRUIT.svg',
      redirectTo: ''
    },*/
    {
      name: 'bSOCIAL',
      logoImg: 'assets/images/imanage-icons/bSocial.svg',
      redirectTo: ''
    },
    {
      name: 'Register Query',
      logoImg: 'assets/images/imanage-icons/Register Query.svg',
      redirectTo: ''
    },
    {
      name: 'LMS',
      logoImg: 'assets/images/imanage-icons/LMS 2.0.svg',
      redirectTo: ''
    },
    {
      name: 'Help & Support',
      logoImg: 'assets/images/HMenu/Group 4340.svg',
      routerLink: 'dashboard/helpSupport'
    },
    {
      name: 'Insta Learn',
      logoImg: 'assets/images/imanage-icons/Insta Learn.svg',
      redirectTo: ''
    },
    {
      name: 'Zing HR',
      logoImg: 'assets/images/imanage-icons/zing-hr.svg',
      redirectTo: ''
    },
    {
      name: 'Quick Quote',
      logoImg: 'assets/images/HMenu/Group 4341.svg',
      redirectTo: ''
    },
    {
      name: 'Customer Servicing',
      logoImg: '/assets/images/imanage-icons/Customer Servicing.svg',
      redirectTo: ''
    },
    {
      name: 'Logout',
      logoImg: 'assets/images/HMenu/Group 4347.svg'
    }
  ];

  imanageTreeDataForCat2 = [
    {
      name: 'Home',
      logoImg: 'assets/images/HMenu/Group 4329.svg',
      routerLink: 'im-dashboard'
    },
    {
      name: 'Blue Book',
      logoImg: '/assets/images/imanage-icons/Care Quote.svg',
      routerLink: ''
    },
    {
      name: 'Opportunity Matrix',
      // logoImg: '/assets/images/imanage-icons/Customer Servicing.svg',
      logoImg: '/assets/im-images/oppurtunity-matrix.svg',
      routerLink: 'opp-matrix'
    },
    {
      name: 'bSOCIAL',
      logoImg: 'assets/images/imanage-icons/bSocial.svg',
      redirectTo: ''
    },
    {
      name: 'Performance Scorecard',
      logoImg: '/assets/images/imanage-icons/Processes.svg',
      routerLink: 'im-performance-management'
    },
    {
      name: 'SM Summary',
      logoImg: '/assets/images/imanage-icons/Register Query.svg',
      routerLink: ''
    },
    {
      name: 'IC / POSP Summary',
      logoImg: 'assets/images/imanage-icons/IC  POSP Summary Blue.svg',
      routerLink: 'ic-posp-summary'
    },
    {
      name: 'Club IC Summary',
      logoImg: 'assets/images/imanage-icons/Investment Corner.svg',
      routerLink: ''
    },
    {
      name: 'Customer Summary',
      logoImg: '/assets/images/imanage-icons/Customer Servicing.svg',
      routerLink: ''
    },
    {
      name: 'i-RECRUIT',
      logoImg: 'assets/images/imanage-icons/i-RECRUIT.svg',
      redirectTo: ''
    },
    {
      name: 'LMS',
      logoImg: 'assets/images/imanage-icons/LMS 2.0.svg',
      redirectTo: ''
    },
    {
      name: 'Care Quote',
      logoImg: 'assets/images/imanage-icons/Care Quote.svg',
      redirectTo: ''
    },
    {
      name: 'Insta Learn',
      logoImg: 'assets/images/imanage-icons/Insta Learn.svg',
      redirectTo: ''
    },
    {
      name: 'Logout',
      logoImg: 'assets/images/HMenu/Group 4347.svg'
    }
  ];

  imanageTreeDataForPSF: TreeList[] = [
    {
      name: 'imanage PSF Dashboard',
      icon: 'assignment',
      routerLink: 'im-dashboard'
    }
  ];

  treeDataForImADP: TreeList[] = [
    {
      name: 'Home',
      logoImg: 'assets/images/HMenu/Group 4329.svg',
      routerLink: 'adp-dashboard'
    },
    {
      name: 'About Us',
      logoImg: 'assets/images/adp-admin-icons/About Us.svg',
      routerLink: 'hamburger/about-us'
    },
    {
      name: 'IC / POSP Details',
      logoImg: 'assets/images/adp-admin-icons/IC  or POSP Details.svg',
      routerLink: 'hamburger/ic-posp-details'
    },
    {
      name: 'ADP Corner',
      logoImg: 'assets/images/imanage-icons/My Profile.svg',
      routerLink: 'hamburger-corner/ADP-Corner'
    },
    {
      name: 'Product Gallery',
      logoImg: 'assets/images/imanage-icons/Product Gallery.svg',
      routerLink: 'admin/admin-products'
    },
    {
      name: 'Compliance',
      logoImg: 'assets/images/adp-admin-icons/Compliance.svg',
      routerLink: 'hamburger-compliance/compliance'
    },
    {
      name: 'Notice Board',
      logoImg: 'assets/images/imanage-icons/Announcement.svg',
      routerLink: 'hamburger-notice-board/Notice-Board'
    },
    {
      name: 'Helpdesk',
      logoImg: 'assets/images/adp-admin-icons/Helpdesk.svg',
      routerLink: 'hamburger/help-desk' //helpdesk-adp
    },
    {
      name: 'GST Invoice',
      logoImg: 'assets/images/imanage-icons/GST-invoive1.svg',
      routerLink: 'hamburger/gst-invoice'
    },
    {
      name: 'DDR & RPD',
      logoImg: 'assets/images/imanage-icons/rrd-ddr1.svg',
      routerLink: 'admin/ddr-rpd'
    },
    {
      name: 'Logout',
      logoImg: 'assets/images/HMenu/Group 4347.svg'
    }
  ];

  treeDataForIMAdmin: TreeList[] = [
    {
      name: 'Add Notice',
      logoImg: 'assets/images/adp-admin-icons/Add Notice.svg',
      routerLink: 'admin/add-notice'
    },
    {
      name: 'New Notification',
      logoImg: 'assets/images/adp-admin-icons/New Notifications.svg',
      routerLink: 'admin/new-notification'
    },
    {
      name: 'SM Scorecard Generation',
      logoImg: 'assets/images/adp-admin-icons/Scorecard Generation.svg',
      routerLink: 'admin/sm-scorecard',
      disable: true
    },
    {
      name: 'Upload Compliance Letter',
      logoImg: 'assets/images/adp-admin-icons/Upload Compliance Letter.svg',
      routerLink: 'admin/upload-compliance-letter'
    },
    {
      name: 'Compliance',
      logoImg: 'assets/images/imanage-admin/Compliance.svg',
      routerLink: 'admin/adp-compliance-hamburger'
    },
    {
      name: 'Resources',
      logoImg: 'assets/images/imanage-admin/Resources-new.svg',
      routerLink: 'admin/resources-manual'
    },
    {
      name: 'Notice Board',
      logoImg: 'assets/images/imanage-admin/Notice Board.svg',
      routerLink: 'admin/announcements'
    },
    {
      name: 'ADP Corner',
      logoImg: 'assets/images/imanage-admin/ADP Corner.svg',
      routerLink: 'admin/adp-corner'
    },
    {
      name: 'Upload Imanage Video',
      logoImg: '/assets/images/ismartAdmin/ic_live-training-presentation.svg',
      routerLink: 'admin/upload-imanage-video'
    },
    {
      name: 'DDR & RPD Details',
      logoImg: 'assets/images/imanage-icons/rrd-ddr1.svg',
      routerLink: 'admin/ddr-rpd'
    },
    {
      name: 'Logout',
      logoImg: 'assets/images/HMenu/Group 4347 -white.svg'
    }
  ];

  treeDataForISAdmin: TreeList[] = [
    {
      name: 'Live Notification',
      logoImg: '/assets/images/ismartAdmin/ic_live-notification.svg',
      routerLink: 'admin/live-notification'
    },
    {
      name: 'New Notification',
      logoImg: '/assets/images/ismartAdmin/ic_new-notification.svg',
      routerLink: 'admin/new-notification-ic'
    },
    {
      name: 'Upload Compliance Letter',
      logoImg: 'assets/images/adp-admin-icons/Upload Compliance Letter.svg',
      routerLink: 'admin/upload-compliance-letter'
    },
    {
      name: 'Upload Files',
      logoImg: '/assets/images/ismartAdmin/ic_upload-files.svg',
      routerLink: 'admin/upload-files'
    },
    {
      name: 'Upload Circular',
      logoImg: '/assets/images/ismartAdmin/ic_upload-circular.svg',
      routerLink: 'admin/upload-circular'
    },
    {
      name: 'Add Notice',
      logoImg: '/assets/images/adp-admin-icons/Add Notice.svg',
      routerLink: 'admin/add-notice'
    },
    {
      name: 'Upload Training Video',
      logoImg: '/assets/images/ismartAdmin/ic_upload-taining-video.svg',
      routerLink: 'admin/upload-training-video'
    },
    {
      name: 'Upload Training Presentation',
      logoImg: '/assets/images/ismartAdmin/ic_live-training-presentation.svg',
      routerLink: 'admin/upload-training-presentation'
    },
    {
      name: 'Upload Partner Carousel Image',
      logoImg: '/assets/images/ismartAdmin/ic_live-training-presentation.svg',
      routerLink: 'admin/upload-partner-carousel-image'
    },
    {
      name: 'Download IC Feedback Data',
      logoImg: '/assets/images/ismartAdmin/ic_download-IC-feedback-data.svg',
      routerLink: 'admin/download-ic-feedback'
    },
    {
      name: 'Trip Registration Details',
      logoImg: 'assets/images/imanage-admin/ADP Corner.svg',
      routerLink: 'admin/trip-details'
    },
    {
      name: 'Logout',
      logoImg: 'assets/images/HMenu/Group 4347 -white.svg'
    }
  ];

  constructor(
    
    private router: Router,
   
    private snackbar: MatSnackBar,
   
  ) {
   // this.urlConfig = this._config.getConfig();
  }
  //Boing//
  // getBoingKey(Userid, codingType): Observable<any> {
  //   return this.http
  //     .get<any>(
  //       `${this.urlConfig.apiList.base_url_partner_auth_host_service.api}/v1/get-encrypt-decrypt-string?value=${Userid}&codingType=${codingType}`
  //     )
  //     .pipe(catchError(this.handleError));
  // }

  // idamService(request): Observable<any> {
  //   this.idamApi = `${this.urlConfig.apiList.idamApi.ip}${this.urlConfig.apiList.idamApi.api}v1/gpm/service/permission-data`;
  //   return this.http
  //     .post<any>(`${this.idamApi}`, request, {
  //       headers: new HttpHeaders({
  //         'Content-Type': 'application/json'
  //       })
  //     })
  //     .pipe(catchError(this.handleError));
  // }
  // getTreesList() {
  //   const role = this.checkUserRole();
  //   if (this.urlConfig.smLevelRoles.includes(role))
  //     return this.imanageTreeDataForSM;
  //   else if (this.urlConfig.agentLevelRoles.includes(role))
  //     return this.ismartTreeData;
  //   else if (this.urlConfig.adpLevelRoles.includes(role))
  //     return this.treeDataForImADP;
  //   else if (this.urlConfig.iSmartAdminLevelRoles.includes(role))
  //     return this.treeDataForISAdmin;
  //   else if (this.urlConfig.iManageAdminLevelRoles.includes(role))
  //     return this.treeDataForIMAdmin;
  //   else return this.ismartTreeData;

  //   // switch (role) {
  //   //   case 'SM':
  //   //     return this.imanageTreeDataForSM;
  //   //   case 'POS-P':
  //   //     return this.ismartTreeData;
  //   //   case 'PSF':
  //   //     return this.imanageTreeDataForPSF;
  //   //   case 'ADP':
  //   //     return this.treeDataForImADP;
  //   //   case 'ADP-P':
  //   //     return this.treeDataForImADP;
  //   //   case 'IC':
  //   //     return this.ismartTreeData;
  //   //   case 'i-manage-admin':
  //   //     return this.treeDataForIMAdmin;
  //   //   case 'i-smart-admin':
  //   //     return this.treeDataForISAdmin;
  //   //   case 'RM':
  //   //   case 'BM':
  //   //   case 'CAO':
  //   //   case 'GM':
  //   //   case 'ZM':
  //   //     return this.imanageTreeDataForCat2;
  //   //   default:
  //   //     return this.ismartTreeData;
  //   // }
  // }

  // checkUserRole() {
  //   return Urls.RoleType; //sessionStorage.getItem('userRole');
  // }

  // getCurrencyFormat(amount: number): string {
  //   return Number(amount).toLocaleString('en-IN', {
  //     minimumFractionDigits: 0,
  //     maximumFractionDigits: 0
  //   });
  // }

  // maskMobileNo(number): any {
  //   number = number.toString().slice(-4);

  //   return '******' + number;
  // }

  // customeDateFormat(adate: string) {
  //   const monthNames = [
  //     'Jan',
  //     'Feb',
  //     'Mar',
  //     'Apr',
  //     'May',
  //     'Jun',
  //     'Jul',
  //     'Aug',
  //     'Sep',
  //     'Oct',
  //     'Nov',
  //     'Dec'
  //   ];

  //   const date = new Date(adate);
  //   date.setDate(date.getDate() - 1);
  //   const formatedDt =
  //     date.getDate() +
  //     '-' +
  //     monthNames[date.getMonth()] +
  //     '-' +
  //     date.getFullYear();
  //   return formatedDt;
  // }

  // titleCaseWord(word: string) {
  //   if (!word) {
  //     return word;
  //   }
  //   return word[0].toUpperCase() + word.substr(1).toLowerCase();
  // }

  toTitleCase(str: string) {
    if (str)
      return str.replace(/\w\S*/g, (txt: string) => {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
      
      return 
  }

  // formatDate(date:any) {
  //   var d = new Date(date),
  //     month = '' + (d.getMonth() + 1),
  //     day = '' + d.getDate(),
  //     year = d.getFullYear();
  //   if (month.length < 2) month = '0' + month;
  //   if (day.length < 2) day = '0' + day;

  //   return [day, month, year].join('-');
  // }
  // formatCurranyNumber(curr: any) {
  //   let res: string = '';
  //   let currencySym: string = '';
  //   let amt = Number(curr);
  //   let val: any;
  //   let cororLabel: string = '';
  //   if (amt || amt == 0) {
  //     if (amt / 10000000 > 1 || amt / 10000000 < -1) {
  //       let amt1 = amt / 10000000;
  //       let amt2 = Math.round(amt1 * 100.0) / 100.0;
  //       val = amt2;
  //       cororLabel = ' Cr.';
  //     } else {
  //       val = Math.round(amt);
  //     }
  //     let lastThree = val.toString().substring(val.toString().length - 3);
  //     const otherNumbers = val
  //       .toString()
  //       .substring(0, val.toString().length - 3);
  //     if (otherNumbers !== '' && otherNumbers !== '-') {
  //       lastThree = ',' + lastThree;
  //     }
  //     res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
  //     currencySym = getCurrencySymbol('INR', 'wide');
  //   }
  //   if (cororLabel) {
  //     res = res.replace(/,/g, '');
  //     return `${currencySym} ${res} ${cororLabel}`;
  //   } else return `${currencySym} ${res} ${cororLabel}`;
  // }

  // config: any;
  // getTdsData() {
  //   return this.http
  //     .get('./assets/data/properties.json')
  //     .toPromise()
  //     .then((config: any) => {
  //       return config;
  //     })
  //     .catch((err: any) => {
  //      //console.error(err);
  //     });
  // }

  // getRoleChangeEmitter() {
  //   return this.isTreeDataChanged;
  // }

  // getBackButtonEmitter() {
  //   return this.isBackbuttonClicked;
  // }

  // getUpdatedNotifCount() {
  //   return this.updatedNotifCount;
  // }

  // getTreeConfig(gpmMenues:any) {
  //   // const concludedArr: any[] = [];
  //   // if (!this.urlConfig.customerServicingIc.includes(Urls.ProfileNo)) {
  //   //   let temp = this.getTreesList().findIndex(
  //   //     (a) => a.name === 'Customer Servicing'
  //   //   );
  //   //   this.getTreesList().splice(temp, 1);
  //   //   this.matchedTreeDt = this.getTreesList();
  //   // } else {
  //   this.matchedTreeDt = this.getTreesList();
  //   //}
  //   // if (gpmMenues) {
  //   //   this.matchedTreeDt.forEach((i) => {
  //   //     // if(gpmMenues.includes(i.name)) concludedArr.push(i)
  //   //     ////console.log(gpmMenues.includes(i.name));
  //   //   });
  //   // }
  //   ////console.log(matchedTreeDt);
  //   let treeConfigObj: TreeNodeConfig = {
  //     treeData: this.matchedTreeDt,
  //     styleAttributes: {
  //       backgroundColor: 'white',
  //       paddingLeft: '5px'
  //     },
  //     parentNodeStyleAttributes: {
  //       color: 'black',
  //       fontSize: '14px'
  //     },
  //     childNodeStyleAttributes: {
  //       color: 'black',
  //       fontSize: '12px'
  //     },
  //     ulPaddingLeft: {
  //       paddingLeft: '0px'
  //     },
  //     textPaddingLeft: {
  //       paddingLeft: '7px'
  //     }
  //   };
  //   return treeConfigObj;
  // }

  // getTreeDataColor() {
  //   const role = Urls.RoleType;
  //   if (this.urlConfig.smLevelRoles.includes(role)) return ['#c4e4f0'];
  //   else if (this.urlConfig.agentLevelRoles.includes(role)) return ['#c4e4f0'];
  //   else if (this.urlConfig.adpLevelRoles.includes(role)) return ['#c4e4f0'];
  //   else if (this.urlConfig.iSmartAdminLevelRoles.includes(role))
  //     return ['#004C8C'];
  //   else if (this.urlConfig.iManageAdminLevelRoles.includes(role))
  //     return ['#004C8C'];
  //   else return ['#c4e4f0'];
  //   // switch (role) {
  //   //   case 'SM':
  //   //     return ['#c4e4f0'];
  //   //   case 'POS-P':
  //   //     return ['#c4e4f0'];
  //   //   case 'PSF':
  //   //     return ['#c4e4f0'];
  //   //   case 'ADP':
  //   //     return ['#c4e4f0'];
  //   //   case 'ADP-P':
  //   //     return ['#c4e4f0'];
  //   //   case 'IC':
  //   //     return ['#c4e4f0'];
  //   //   case 'i-manage-admin':
  //   //     return ['#004C8C'];
  //   //   case 'i-smart-admin':
  //   //     return ['#004C8C'];
  //   //   default:
  //   //     return ['#c4e4f0'];
  //   // }
  // }
  // https://balicuat.bajajallianz.com/NewSMPortal/smportal/LMSEnc/getEncrypted
  // reloadComponent() {
  //   // let loggedRole = this.checkUserRole();
  //   // if (this.urlConfig.smLevelRoles.includes(loggedRole)) {
  //   //   this.router.navigate(['/im-dashboard']);
  //   // } else if (this.urlConfig.agentLevelRoles.includes(loggedRole)) {
  //   //   this.router.navigate(['/dashboard']);
  //   // } else if (this.urlConfig.adpLevelRoles.includes(loggedRole)) {
  //   //   this.router.navigate(['/adp-dashboard']);
  //   // } else if (this.urlConfig.iManageAdminLevelRoles.includes(loggedRole)) {
  //   //   this.router.navigate(['/admin/add-notice']);
  //   // } else if (this.urlConfig.iSmartAdminLevelRoles.includes(loggedRole)) {
  //   //   this.router.navigate(['/admin/live-notification']);
  //   // } else if (this.urlConfig.cat2LevelRoles.includes(loggedRole)) {
  //   //   this.router.navigate(['/im-dashboard']);
  //   // }
  //   this.router.navigate(['/e-sampark']);
  // }

  // postLms(clientId: postLmsInterface) {
  //   return this.http
  //     .post<any>(
  //       `https://balicuat.bajajallianz.com/NewSMPortal/smportal/LMSEnc/getEncrypted`,
  //       clientId,
  //       {
  //         headers: new HttpHeaders({
  //           'Content-Type': 'application/json'
  //         })
  //       }
  //     )
  //     .pipe(catchError(this.handleError));
  // }

  // getLms(tokenLms) {
  //   return this.http.get<any>(
  //     `https://sales.bajajallianzlife.com/BalicLmsWeb/sso/lmsempService?empCode=${tokenLms}`
  //   );
  // // }
  // getIdashboardTabs() {
  //   let tabs: any;
  //   tabs = [
  //     {
  //       title: 'Sales Contest',
  //       icon: '/assets/im-images/sales-contest.svg',
  //       redirectTo: 'sales-contest',
  //       featureName: 'sm_sales_contest'
  //     },
  //     {
  //       title: 'Team Performance',
  //       icon: '/assets/im-images/team-performance.svg',
  //       redirectTo: 'team-performance',
  //       featureName: 'sm_team_performance'
  //     },
  //     {
  //       title: 'My Goalsheet',
  //       icon: '/assets/im-images/my-goalsheet.svg',
  //       redirectTo: 'my-goalsheet',
  //       featureName: 'sm_my_goalsheet'
  //     },
  //     {
  //       title: 'IC/POSP Appointment',
  //       icon: '/assets/im-images/ic-posp-appointment.svg',
  //       redirectTo: 'ic-posp-appointment',
  //       featureName: 'sm_ic_posp_appointment'
  //     },
  //     {
  //       title: 'Customer Search',
  //       icon: 'assets/images/Dashboard Icons/customer-search-dashboard.svg',
  //       redirectTo: 'im-customer-portfolio',
  //       featureName: 'sm_ic_posp_appointment'
  //     },
  //     // {
  //     //   title: 'GPA',
  //     //   icon: '/assets/im-images/gpa.svg',
  //     //   redirectTo: 'gpa',
  //     //   featureName: 'sm_gpa'
  //     // },
  //     {
  //       title: 'Opp. Matrix',
  //       icon: '/assets/im-images/oppurtunity-matrix.svg',
  //       redirectTo: 'opp-matrix',
  //       featureName: 'sm_opp_matrix'
  //     },
  //     {
  //       title: 'Team Performance',
  //       icon: '/assets/im-images/team-performance.svg',
  //       redirectTo: 'team-performance',
  //       featureName: 'adp_team_performance'
  //     },
  //     {
  //       title: 'My Business',
  //       icon: '/assets/images/adp-admin-icons/My Business.svg',
  //       redirectTo: '/adp-dashboard/my-business-adp',
  //       featureName: 'adp_my_business'
  //     },
  //     {
  //       title: 'My Earnings',
  //       icon: '/assets/images/adp-admin-icons/My Earning.svg',
  //       redirectTo: '/adp-dashboard/my-earnings',
  //       featureName: 'adp_my_earnings'
  //     },
  //     {
  //       title: 'Persistency',
  //       icon: '/assets/images/adp-admin-icons/Persistency.svg',
  //       redirectTo: '/adp-dashboard/persistency',
  //       featureName: 'adp_persistency'
  //     },
  //     {
  //       title: 'IC / POSP',
  //       icon: '/assets/im-images/ic-posp-appointment.svg',
  //       redirectTo: '/im-dashboard/ic-posp',
  //       featureName: 'adp_ic_posp'
  //     },
  //     {
  //       title: 'Sales Contest',
  //       icon: '/assets/im-images/sales-contest.svg',
  //       redirectTo: '/adp-dashboard/sales-contest-adp',
  //       featureName: 'adp_sales_contest_tab'
  //     },
  //     {
  //       title: 'Sales Contest',
  //       icon: '/assets/im-images/sales-contest.svg',
  //       redirectTo: '/adp-dashboard/sales-contest-adp',
  //       featureName: 'bm_sales_contest'
  //     },
  //     {
  //       title: 'On Track Benefit',
  //       icon: '/assets/im-images/team-performance.svg',
  //       redirectTo: 'team-performance',
  //       featureName: 'bm_on_track_benefit'
  //     },
  //     {
  //       title: 'Goalsheet',
  //       icon: '/assets/im-images/my-goalsheet.svg',
  //       redirectTo: 'my-goalsheet',
  //       featureName: 'bm_goalsheet'
  //     },
  //     {
  //       title: 'IC/POSP Appointment',
  //       icon: '/assets/im-images/ic-posp-appointment.svg',
  //       redirectTo: 'ic-posp-appointment',
  //       featureName: 'bm_ic_posp_appointment'
  //     },
  //     {
  //       title: 'IC/ POSP / SM Activation',
  //       icon: '/assets/im-images/gpa.svg',
  //       redirectTo: 'ic-posp-sm-activation',
  //       featureName: 'bm_ic_posp_sm_activation'
  //     },
  //     {
  //       title: 'Quality Metrics',
  //       icon: '/assets/im-images/ic-posp-appointment.svg',
  //       redirectTo: '/quality-metrics',
  //       featureName: 'bm_quality_metrics'
  //     },
  //     {
  //       title: 'Product Mix',
  //       icon: '/assets/im-images/sales-contest.svg',
  //       redirectTo: '/adp-dashboard/sales-contest-adp',
  //       featureName: 'cao_product_mix'
  //     },
  //     {
  //       title: 'Business Quality',
  //       icon: '/assets/im-images/team-performance.svg',
  //       redirectTo: 'team-performance',
  //       featureName: 'cao_buisness_quality'
  //     },
  //     {
  //       title: 'IC/POSP Appointment',
  //       icon: '/assets/im-images/ic-posp-appointment.svg',
  //       redirectTo: 'ic-posp-appointment',
  //       featureName: 'cao_ic_posp_appointment'
  //     },
  //     {
  //       title: 'New IC / POSP Productivity',
  //       icon: '/assets/im-images/ic-posp-appointment.svg',
  //       redirectTo: 'ic-posp-appointment',
  //       featureName: 'cao_new_ic_posp_productivity'
  //     },
  //     {
  //       title: 'IC / POSP / SM Activation',
  //       icon: '/assets/im-images/gpa.svg',
  //       redirectTo: 'ic-posp-sm-activation',
  //       featureName: 'cao_new_ic_posp_sm_activation'
  //     },
  //     {
  //       title: 'On Track',
  //       icon: '/assets/im-images/ic-posp-appointment.svg',
  //       redirectTo: '',
  //       featureName: 'cao_on_track'
  //     }
  //   ];
  //   return tabs;
  // }

  // getOppRoutes() {
  //   let oppRoutes = {
  //     '/im-dashboard': 'Dashboard',
  //     '/im-dashboard/new-business#mtd-login': 'MTD Login',
  //     '/im-dashboard/new-business#mtd-issued': 'MTD Issued',
  //     '/im-dashboard/new-business#pending-proposal': 'Pending Proposal',
  //     '/im-dashboard/opp-matrix': 'Opportunity Matrix',
  //     '/im-dashboard/opp-matrix/PASA': 'PASA',
  //     '/im-dashboard/opp-matrix/MATURITY': 'Maturity',
  //     '/im-dashboard/opp-matrix/DISCONTINUED': 'Discontinued Fund',
  //     '/im-dashboard/opp-matrix/LAPSED': 'Lapsed Policy',
  //     '/im-dashboard/opp-matrix/TERM%20NOT%20SOLD': 'Term Not Sold',
  //     '/im-dashboard/opp-matrix/UNCLAIMED': 'Unclaimed',
  //     '/ic-posp-summary': 'IC / POSP Summary',
  //     '/ic-posp-summary/ic-summary': 'IC Summary',
  //     '/ic-posp-summary/posp-summary': 'POSP Summary',
  //     '/ic-posp-summary/mbg-summary': 'MBG Summary',
  //     '/quality-metrics': 'Quality Metrics',
  //     '/hamburger-notice/notice/IRDA%20Circular': 'IRDA Circular',
  //     '/hamburger-notice/notice/Current%20News': 'Current News',
  //     '/hamburger-notice/notice/Notice%20&%20Circular': 'Notice & Circular',
  //     '/hamburger-corner/ADP-Corner/my-profile-adp': 'My Profile',
  //     '/hamburger-corner/ADP-Corner/AMC%20Norms': 'AMC Norms',
  //     '/hamburger-corner/ADP-Corner/TDS%20Certificate': 'TDS Certificate',
  //     '/hamburger-corner/ADP-Corner/User%20Guide': 'User Guide',
  //     "/hamburger-corner/ADP-Corner/FAQ's": "FAQ's",
  //     '/hamburger-notice-board/Notice-Board/GST%20Guidelines': 'GST Guidelines',
  //     '/hamburger-notice-board/Notice-Board/Compensation%20Letter':
  //       'My Compensation',
  //     '/hamburger-notice/notice/sm-uploaded-docs': 'Uploaded Documents',
  //     '/hamburger-compliance/Guidelines/Guidelines:Archive': 'Archives',
  //     '/hamburger-compliance/Guidelines/Guidelines': 'Guidelines',
  //     '/notifications': 'Notifications',
  //     '/new-business-tabs#mtd-login': 'New Business',
  //     '/new-business-tabs#mtd-issued': 'New Business',
  //     '/new-business#pending-proposal': 'New Business',
  //     '/adp-dashboard/new-business-tabs#nb-login': 'Login',
  //     '/adp-dashboard/new-business-tabs#nb-issued': 'Issued',
  //     '/adp-dashboard/new-business#pending-proposal': 'Pending Proposal',
  //     '/adp-dashboard/bpi-details': 'ADP Performance',
  //     '/adp-dashboard/bpi-details-adp-premier': 'ADP Performance',
  //     '/im-dashboard/bpi-details': 'BPI',
  //     '/im-dashboard/bpi': 'BPI',
  //     '/notifications/all-notifications#Customer%20Notifications':
  //       'Customer Notifications'
  //   };
  //   return oppRoutes;
  // }

  // public generateBirthdayTemplate(item: any) {
  //   return `?Subject=Bajaj Allianz wishes you a very Happy Birthday!&body=
  //   Dear ${item.policyNumber},
  //   %0D%0A
  //   %0D%0A
  //   Wish you a very happy Birthday and a wonderful year ahead!
  //   %0D%0A
  //   %0D%0A
  //   %0D%0A
  //   ${Urls.userFirstName} ${
  //     Urls.userLastName || Urls.userLastName != 'undefined'
  //       ? Urls.userLastName
  //       : ''
  //   },
  //   %0D%0A
  //   Bajaj Allianz Life Insurance Co. Ltd`;
  // }

  // public generateRenewalRTemplate(item: any) {
  //   return `?Subject=Your policy number ${item.policyNumber} is due for renewal&body=
  //   'Greetings from Bajaj Allianz Life Insurance, your life goals enabler.
  //   %0D%0A
  //   %0D%0A
  //   Your policy number ${item.policyNumber}. is due for renewal, and as your life goals enabler, it is our responsibility to ensure that your life goals are on track, and the premiums are paid on time.
  //   %0D%0A
  //   %0D%0A
  //   In case you may have any queries on the policy, or any of our products designed to help you get your Life Goals DONE, you can reach us on our toll free customer
  //   %0D%0A
  //   %0D%0A
  //   service number 1800-209-7272, or log on to chat with BOING, our virtual assistant chat bot 2S1PPyM> or simply log on to Life Assist
  //   %0D%0A
  //   CustomerPortal/logon/index.jsp#!/login>, our customer portal.
  //   %0D%0A
  //   %0D%0A
  //   Helping you stay on track with your life goals will always be our priority and we assure you the best of our services.
  //   %0D%0A
  //   %0D%0A
  //   %0D%0A
  //   Warm regards
  //   %0D%0A
  //   Bajaj Allianz Life Insurance Co. Ltd
  //   `;
  // }

  // public openCommonDialog(options:any) {
  //   this.dialogRef = this.dialog.open(CommonDialogComponent, {
  //     data: {
  //       title: options.title,
  //       message: options.message,
  //       cancelText: options.cancelText,
  //       confirmText: options.confirmText,
  //       panelClass: options.panelClass
  //     }
  //   });
  // }

  // public confirmedCommonDialog(): Observable<any> {
  //   return this.dialogRef.afterClosed().pipe(
  //     take(1),
  //     map((res) => {
  //       return res;
  //     })
  //   );
  // }

  // public handleError(error: HttpErrorResponse) {
  //   // let errorMessage = '';
  //   ////console.log('called error handler function');
  //   // if (error.error instanceof ErrorEvent) {
  //   // A client-side or network error occurred. Handle it accordingly.
  //   // errorMessage = error.error.message;
  //   //  //console.error('An error occurred:', error.error.message);
  //   // } else {
  //   // The backend returned an unsuccessful response code.
  //   // The response body may contain clues as to what went wrong,
  //   // errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
  //   //  //console.error(
  //   //     `Backend returned code ${error.status}, ` + `body was: ${error.error}`
  //   //   );
  //   // }
  //   // return an observable with a user-facing error message
  //   // this.errorData = {
  //   //   message: 'Oops! Request for document failed',
  //   //   details: ['Something bad happened. Please try again later.'],
  //   //   errCode: 'ERR400'
  //   // };
  //   // return throwError(this.errorData);
  //   return throwError(error);
  // }

  openSnackbar(
    error:any,
    type: 'error' | 'warning' | 'success',
    customMsg?: string,
    duration?: number,
    vPosition?: 'bottom' | 'top',
    hPosittion?: 'center' | 'left' | 'right' | 'start' | 'end'
  ): boolean {
    if (customMsg || (error.error && error.error.message)) {
      this.snackbar.open(customMsg ? customMsg : error.error.message, 'X', {
        duration: duration ? duration : 5000,
        verticalPosition: vPosition ? vPosition : 'top',
        horizontalPosition: hPosittion ? hPosittion : 'right',
        panelClass: [type]
      });
    } else if (error.status == 0) {
      this.showSnakkerMessage(
        'System error encountered. Please contact administrator.',
        'error'
      );
    } else if (error.status == 504) {
      this.showSnakkerMessage('Gateway timeout. Please try again.', 'error');
    } else if (error.status == 503) {
      this.showSnakkerMessage('Connection timeout. Please try again.', 'error');
    } else if (error.status == 403) {
      this.showSnakkerMessage(
        'Service access forbidden. Please contact administrator',
        'error'
      );
    } else if (error.status == 404) {
      this.showSnakkerMessage('No data found.', 'error');
    } else {
      this.showSnakkerMessage('Internal server error!!', 'error');
    }
    return true;
  }

  showSnakkerMessage(
    message: string,
    type: 'error' | 'warning' | 'success',
    duration?: number,
    vPosition?: 'bottom' | 'top',
    hPosittion?: 'center' | 'left' | 'right' | 'start' | 'end'
  ) {
    this.snackbar.open(message, 'X', {
      duration: duration ? duration : 5000,
      verticalPosition: vPosition ? vPosition : 'top',
      horizontalPosition: hPosittion ? hPosittion : 'right',
      panelClass: [type]
    });
    return true;
  }

  // customerServicingDateFormat(date: string) {
  //   // 01/AUG/2019
  //   if (date && date.indexOf('/') > -1) {
  //     let formatedDate = date.replace(/\//g, '-');
  //     return formatedDate;
  //   } else if (date && date.indexOf('-') > -1) {
  //     return date;
  //   }
  // }

  // getRoleFromProfileNo(profileCode: any) {
  //   if (profileCode) {
  //     const convertedArr = Object.entries(this.urlConfig.validations);
  //     const allRoles = [];
  //     convertedArr.forEach((ele) => {
  //       allRoles.push(ele[1]);
  //     });
  //     const filteredRoles = allRoles.filter((ele) => ele.role);
  //     let roleType = '';
  //     filteredRoles.forEach((el) => {
  //       if (profileCode.match(el.regexInput)) roleType = el.role;
  //     });
  //     if (roleType) return roleType;
  //     else '';
  //     // .filter((ele)=>{
  //     //   return ele.role
  //     // })
  //     // if (profileCode.match(this.urlConfig.validations.icCode.regexInput))
  //     //   return 'IC';
  //     // else if (
  //     //   profileCode.match(this.urlConfig.validations.pospCode.regexInput)
  //     // )
  //     //   return 'POS-P';
  //     // else if (profileCode.match(this.urlConfig.validations.smCode.regexInput))
  //     //   return 'SM';
  //     // else if (profileCode.match(this.urlConfig.validations.adpCode.regexInput))
  //     //   return 'ADP';
  //     // else if (
  //     //   profileCode.match(this.urlConfig.validations.adppCode.regexInput)
  //     // )
  //     //   return 'ADP-P';
  //   }
  // }
  //download PDF from BYTE array
  // downloadPDFDoc(doc: any, fileName: string) {
  //   // var FileSaver = require('file-saver');
  //   const fileByteCharacters = atob(
  //     doc.pdfData ? doc.pdfData : doc.pdfdata ? doc.pdfdata : doc.base64File
  //   );
  //   const fileByteNumbers = new Array(fileByteCharacters.length);
  //   for (let i = 0; i < fileByteCharacters.length; i++) {
  //     fileByteNumbers[i] = fileByteCharacters.charCodeAt(i);
  //   }
  //   const byteArray = new Uint8Array(fileByteNumbers);
  //   const blob = new Blob([byteArray], { type: 'application/pdf' });
  //   FileSaver.saveAs(blob, fileName);
  // }

  // checkProfileNoIsOfRole(profileCode: string, role: string) {
  //   let isProfileNoIsOfRole: boolean = false;
  //   if (profileCode && role) {
  //     if (role === 'IC') {
  //       isProfileNoIsOfRole = profileCode.match(
  //         this.urlConfig.validations.icCode.regexInput
  //       )
  //         ? true
  //         : false;
  //     } else if (role === 'SM') {
  //       isProfileNoIsOfRole = profileCode.match(
  //         this.urlConfig.validations.smCode.regexInput
  //       )
  //         ? true
  //         : false;
  //     } else if (role === 'POS-P') {
  //       isProfileNoIsOfRole = profileCode.match(
  //         this.urlConfig.validations.pospCode.regexInput
  //       )
  //         ? true
  //         : false;
  //     } else if (role === 'ADP') {
  //       isProfileNoIsOfRole = profileCode.match(
  //         this.urlConfig.validations.adpCode.regexInput
  //       )
  //         ? true
  //         : false;
  //     } else if (role === 'ADP-P') {
  //       isProfileNoIsOfRole = profileCode.match(
  //         this.urlConfig.validations.adppCode.regexInput
  //       )
  //         ? true
  //         : false;
  //     } else if (role === 'CRP') {
  //       isProfileNoIsOfRole = profileCode.match(
  //         this.urlConfig.validations.crpCode.regexInput
  //       )
  //         ? true
  //         : false;
  //     } else if (role === 'SRP') {
  //       isProfileNoIsOfRole = profileCode.match(
  //         this.urlConfig.validations.srpCode.regexInput
  //       )
  //         ? true
  //         : false;
  //     } else if (role === 'RP') {
  //       isProfileNoIsOfRole = profileCode.match(
  //         this.urlConfig.validations.rpCode.regexInput
  //       )
  //         ? true
  //         : false;
  //     } else if (role === 'ARP') {
  //       isProfileNoIsOfRole = profileCode.match(
  //         this.urlConfig.validations.arpCode.regexInput
  //       )
  //         ? true
  //         : false;
  //     } else if (role === 'IM') {
  //       isProfileNoIsOfRole = profileCode.match(
  //         this.urlConfig.validations.imCode.regexInput
  //       )
  //         ? true
  //         : false;
  //     } else if (role === 'EIM') {
  //       isProfileNoIsOfRole = profileCode.match(
  //         this.urlConfig.validations.eimCode.regexInput
  //       )
  //         ? true
  //         : false;
  //     } else if (role === 'CAO') {
  //       isProfileNoIsOfRole = profileCode.match(
  //         this.urlConfig.validations.caoCode.regexInput
  //       )
  //         ? true
  //         : false;
  //     } else if (role === 'ZM') {
  //       isProfileNoIsOfRole = profileCode.match(
  //         this.urlConfig.validations.zmCode.regexInput
  //       )
  //         ? true
  //         : false;
  //     } else if (role === 'GM') {
  //       isProfileNoIsOfRole = profileCode.match(
  //         this.urlConfig.validations.gmCode.regexInput
  //       )
  //         ? true
  //         : false;
  //     } else if (role === 'RM') {
  //       isProfileNoIsOfRole = profileCode.match(
  //         this.urlConfig.validations.rmCode.regexInput
  //       )
  //         ? true
  //         : false;
  //     } else if (role === 'BM') {
  //       isProfileNoIsOfRole = profileCode.match(
  //         this.urlConfig.validations.bmCode.regexInput
  //       )
  //         ? true
  //         : false;
  //     }

  //     if (!isProfileNoIsOfRole) {
  //       this.snackbar.open(
  //         'Entered Profile Code does not belong to selected Role Type',
  //         'x',
  //         {
  //           duration: 5000,
  //           verticalPosition: 'bottom',
  //           horizontalPosition: 'right',
  //           panelClass: ['error']
  //         }
  //       );
  //     }
  //     return isProfileNoIsOfRole;
  //   } else return false;
  // }

  // roleIsNotFromDropdown() {
  //   this.snackbar.open(
  //     `Entered Profile Code does not belong to the dropdown roles`,
  //     'x',
  //     {
  //       duration: 5000,
  //       verticalPosition: 'bottom',
  //       horizontalPosition: 'right',
  //       panelClass: ['error']
  //     }
  //   );
  //   return '';
  // }
  // generateProfileRoleObj(
  //   rolesDropdown: any[],
  //   profileCode?: string,
  //   selectedRole?: string
  // ) {
  //   let validatedObj: RoleProfileChecks = {
  //     profileNo: profileCode ? profileCode : '',
  //     role: selectedRole ? selectedRole : '',
  //     isValid: false,
  //     errorInfoMsg: false
  //   };
  //   let returenedRole = this.getRoleFromProfileNo(profileCode);
  //   if (!profileCode && !selectedRole) {
  //     validatedObj.errorInfoMsg = true;
  //   } else if (profileCode && !selectedRole) {
  //     validatedObj.role = rolesDropdown.includes(returenedRole)
  //       ? returenedRole
  //       : this.roleIsNotFromDropdown();
  //     validatedObj.role === ''
  //       ? (validatedObj.isValid = false)
  //       : (validatedObj.isValid = true);
  //   } else if (!profileCode && selectedRole) {
  //     validatedObj.role = rolesDropdown.includes(selectedRole)
  //       ? selectedRole
  //       : this.roleIsNotFromDropdown();
  //     validatedObj.role === ''
  //       ? (validatedObj.isValid = false)
  //       : (validatedObj.isValid = true);
  //   } else if (profileCode && selectedRole) {
  //     //pn - 110 role- ic should be invalid
  //     validatedObj.isValid = this.checkProfileNoIsOfRole(
  //       profileCode,
  //       selectedRole
  //     )
  //       ? true
  //       : false;
  //   } else {
  //     validatedObj.isValid = true;
  //   }

  //   return validatedObj;
  // }

  // getGenericFinancialYears(startDt:any) {
  //   let startYear = startDt; //this.urlConfig.customerServicingStartYear;
  //   let financialYears = [];
  //   var currentYear = new Date().getFullYear() + 1,
  //     years = [];
  //   startYear = startYear || 1980;
  //   while (startYear <= currentYear) {
  //     years.push(startYear++);
  //   }
  //   for (let i = 0; i < years.length - 1; i++) {
  //     financialYears.push({
  //       displayYear: years[i] + '-' + years[i + 1].toString().substr(2, 2),
  //       keyYear: years[i] + '-' + years[i + 1]
  //     });
  //   }
  //   return financialYears;
  // }

  //fetches profile no from pmacs
  // setProfile(): Observable<boolean> {
  //   const x = this.keycloakAngular.getKeycloakInstance().resourceAccess;
  //   // to get client level roles
  //   const clients = Object.keys(x);
  //   let role: string[];
  //   clients.forEach((c) => {
  //     if (c === this.urlConfig.keycloak.clientId) {
  //       role = x[c].roles;
  //     }
  //   });
  //   const heirarchyUrl = `${this.urlConfig.apiList.base_url_profile.api}/v1/profile-details?profileEmpCode=${Urls.EmpNo}`;

  //   const profileNoMapping = {
  //     cat1: (): Observable<boolean> => {
  //       this.spinner.show('loader');
  //       return this.http
  //         .get(heirarchyUrl, {
  //           headers: new HttpHeaders({
  //             'Content-Type': 'application/json'
  //           })
  //         })
  //         .pipe(
  //           map((res: any) => {
  //             let parsedRes = res[0];
  //             if (parsedRes.profileNo) {
  //               console.log(
  //                 'addORRemoveCustmerServcingMenu',
  //                 parsedRes.profileNo
  //               );
  //               this.addORRemoveCustmerServcingMenu(parsedRes.profileNo);
  //               Urls.ProfileNo = parsedRes.profileNo.toUpperCase();
  //               Urls.RoleType = parsedRes.profileType
  //                 ? parsedRes.profileType
  //                 : Urls.RoleType;
  //               if (Urls.userFirstName) {
  //                 Urls.userFirstName = parsedRes.profileName.split(' ')[0];
  //                 Urls.userLastName = parsedRes.profileName.split(' ')[1]
  //                   ? parsedRes.profileName.split(' ')[1]
  //                   : '';
  //               }
  //               if (!Urls.userEmailId)
  //                 Urls.userEmailId = parsedRes.profileEmailId
  //                   ? parsedRes.profileEmailId
  //                   : '';

  //               this.spinner.hide('loader');
  //               return true;
  //             } else {
  //               this.unAuthorisedNLogout();
  //               this.spinner.hide('loader');
  //               return false;
  //             }
  //             // this.getProfile(Urls.ProfileNo).subscribe(
  //             //   (res) => {
  //             //     this.profileDetailsPMACS.next(res);
  //             //   },
  //             //   (error) => {
  //             //     this.openSnackbar(error, 'error');
  //             //   }
  //             // );
  //           }),
  //           catchError((error) => {
  //             this.spinner.hide('loader');
  //             this.unAuthorisedNLogout();
  //             return throwError(error);
  //           })
  //         );
  //     },
  //     cat2: (): Observable<boolean> => {
  //       Urls.ProfileNo = this.keycloakAngular
  //         .getKeycloakInstance()
  //         .profile.username.toUpperCase();
  //       return of(true);
  //     },
  //     cat3: (): Observable<boolean> => {
  //       Urls.ProfileNo = this.keycloakAngular
  //         .getKeycloakInstance()
  //         .profile.username.toUpperCase();
  //       return of(true);
  //     }
  //   };
  //   return profileNoMapping[this.urlConfig.idamRoles[role[0]]]();
  // }

  // getProfile(id: any): Observable<PMACSProfileDetails> {
  //   const getPRNUrl = `${
  //     this.urlConfig.apiList.base_url_profile.api
  //   }/v1/profile-number/${id}`;
  //   return this.http.get<PMACSProfileDetails>(
  //     `${getPRNUrl}`
  //   );
  // }

  // notificationMsgLinks(inputText: string) {
  //   var replacedText, httpPattern, wwwPattern, emailPattern;
  //   if (inputText) {
  //     //URLs starting with http://, https://, or ftp://
  //     httpPattern =
  //       /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
  //     if (inputText.indexOf('training-corner') > -1) {
  //       replacedText = inputText.replace(
  //         httpPattern,
  //         `<a class="tinyurl" href="/hamburger-ismart/training-corner">$1</a>`
  //       );
  //     } else {
  //       replacedText = inputText.replace(
  //         httpPattern,
  //         '<a class="tinyurl" href="$1' +
  //           Urls.IsAPKOrWeb +
  //           '" target="_blank">$1</a>'
  //       );
  //     }
  //     //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
  //     wwwPattern = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
  //     replacedText = replacedText.replace(
  //       wwwPattern,
  //       '$1<a class="tinyurl" href="http://$2' +
  //         Urls.IsAPKOrWeb +
  //         '" target="_blank">$2</a>'
  //     );

  //     // //Change email addresses to mailto:: links.
  //     emailPattern = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
  //     replacedText = replacedText.replace(
  //       emailPattern,
  //       '<a class="tinyurl" href="mailto:$1">$1</a>'
  //     );
  //   }
  //   return replacedText;
  // }

  // // logout() {
  // //   sessionStorage.clear();
  // //   this.keycloakAngular.logout(window.location.origin + '?logout=true');
  // // }

  // // generateKeyValPair(valueArr: any[], keyValueDiff?: string) {
  // //   const generatedArr = [];

  // //   if (valueArr.length > 0) {
  // //     valueArr.forEach((ele) => {
  // //       if (keyValueDiff == 'ageRange') {
  // //         let inYearVal = `${ele.split('-')[0]} years - ${
  // //           ele.split('-')[1]
  // //         } years`;
  // //         generatedArr.push({ key: ele, value: inYearVal });
  // //       } else generatedArr.push({ key: ele, value: ele });
  // //     });
  // //     return generatedArr;
  // //   }
  // // }

  // // unAuthorisedNLogout() {
  // //   this.openSnackbar(
  // //     null,
  // //     'error',
  // //     "You're not authorized to access this application. Please contact to admin."
  // //   );
  // //   setTimeout(() => {
  // //     this.logout();
  // //   }, 5000);
  // // }

  // getFYearRange() {
  //   /*Remember Start Year should be less than current year*/
  //   let startYear = this.urlConfig.customerServicingStartYear;
  //   let financialYears = [];
  //   var currentYear = new Date().getFullYear() + 1,
  //     years = [];
  //   startYear = startYear || 1980;
  //   while (startYear <= currentYear) {
  //     years.push(startYear++);
  //   }
  //   for (let i = 0; i < years.length - 1; i++) {
  //     financialYears.push({
  //       displayYear: years[i] + '-' + years[i + 1].toString().substr(2, 2),
  //       keyYear: years[i] + '-' + years[i + 1]
  //     });
  //   }
  //   let fyears = financialYears.map((role) => {
  //     return {
  //       key: role.keyYear,
  //       value: role.displayYear
  //     };
  //   });
  //   return fyears;
  // }

  // addORRemoveCustmerServcingMenu(profileNo) {
  //   console.log('fun def addORRemoveCustmerServcingMenu', profileNo);
  //   // if (!this.urlConfig.customerServicingIc.includes(profileNo)) {
  //   //   let temp = this.getTreesList().findIndex(
  //   //     (a) => a.name === 'Customer Servicing'
  //   //   );

  //   //   this.getTreesList().splice(temp, 1);
  //   //   this.matchedTreeDt = this.getTreesList();
  //   // } else {
  //   if (
  //     this.getTreesList().find((item) => item.name === 'Customer Servicing')
  //   ) {
  //     this.matchedTreeDt = this.getTreesList();
  //   } else {
  //     const targetIndex =
  //       this.getTreesList().findIndex((i) => i.name === 'Logout') - 1;
  //     const customerServicingIcMenu = {
  //       name: 'Customer Servicing',
  //       logoImg: '/assets/images/imanage-icons/Customer Servicing.svg',
  //       redirectTo: ''
  //     };
  //     this.getTreesList().splice(targetIndex, 0, customerServicingIcMenu);
  //   }
  // }
  // //}
}
